<template>
  <div class="page">
    <div class="record-wrapper">
      <div class="header">
        <div class="record-title">
          <font-awesome-icon :icon="['fas', 'address-book']" class="icon" />
          <p class="record-subtitle">My Team</p>
          <router-link to="/search?category=contact&query=" class="record-link"
            >View My Team</router-link
          >
        </div>
      </div>
      <ul class="record">
        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon :icon="['fas', 'file']" class="icon" />
            <p class="record-subtitle">Diagnosis</p>
            <!-- <p class="record-explanation">Diagnosis</p> -->
            <router-link to="/currentDiagnosis" class="record-link"
              >View Diagnosis</router-link
            >
          </div>
        </li>

        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon :icon="['fas', 'calendar-alt']" class="icon" />
            <p class="record-subtitle">Medication</p>
            <!-- <p class="record-explanation">Medication</p> -->
            <router-link to="/currentMedications" class="record-link"
              >View Medication</router-link
            >
          </div>
        </li>

        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon :icon="['fas', 'calendar-check']" class="icon" />
            <p class="record-subtitle">Vitals</p>
            <!-- <p class="record-explanation">Vaccination</p> -->
            <router-link to="/vitalsGroup/all" class="record-link"
              >View Vitals</router-link
            >
          </div>
        </li>

        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon :icon="['fas', 'calendar-check']" class="icon" />
            <p class="record-subtitle">Allergy</p>
            <!-- <p class="record-explanation">Allergy</p> -->
            <router-link to="/allergy" class="record-link">View Allergies</router-link>
          </div>
        </li>

        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon :icon="['fas', 'user-md']" class="icon" />
            <p class="record-subtitle">Providers</p>
            <router-link to="/currentProviders" class="record-link"
              >View Providers</router-link
            >
          </div>
        </li>
        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon :icon="['fas', 'user-md']" class="icon" />
            <p class="record-subtitle">Nurses</p>
            <router-link to="/patientNurse" class="record-link">View Nurses</router-link>
          </div>
        </li>
        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon :icon="['fas', 'notes-medical']" class="icon" />
            <p class="record-subtitle">Procedures</p>
            <router-link to="/currentProcedures" class="record-link"
              >View Procedures</router-link
            >
          </div>
        </li>

        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon :icon="['fas', 'thumbtack']" class="icon" />
            <p class="record-subtitle">Notes</p>
            <a
              href="#"
              class="record-link"
              @click.prevent="openNotes"
            >View Notes</a>
          </div>
        </li>

        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon :icon="['fas', 'prescription-bottle']" class="icon" />
            <p class="record-subtitle">Orders</p>
            <a
              href="#"
              class="record-link"
              @click.prevent="openOrders"
            >View Orders</a>
          </div>
        </li>

        <li v-if="canReadDirectives" class="record-item">
          <div class="record-title">
            <font-awesome-icon :icon="['fas', 'clipboard-check']" class="icon" />
            <p class="record-subtitle">Directives</p>
            <router-link to="/directives" class="record-link">View Directives</router-link>
          </div>
        </li>

        <!-- Opens the media prototype on this chart's patient. Gate it on the media view privilege
             once the backend seeds one, as Directives is gated above. -->
        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon :icon="['fas', 'images']" class="icon" />
            <p class="record-subtitle">Media</p>
            <router-link :to="mediaLink" class="record-link">View Media</router-link>
          </div>
        </li>

        <li class="record-item">
          <div class="record-title">
            <font-awesome-icon :icon="['fas', 'calendar-check']" class="icon" />
            <p class="record-subtitle">Patient Availability</p>
            <router-link to="/scheduling?view=patient-availability" class="record-link"
              >View Availability</router-link
            >
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { usePrivilegesStore } from "@/stores/privileges";
import { PRIVILEGES } from "@/constants/privileges";
import { mediaLinkFor } from "@/components/private-layouts/media/mediaNav";

export default {
  name: "WelcomeHealthRecords",
  computed: {
    ...mapGetters("login", { allData: "getAllData" }),
    mediaLink() {
      return mediaLinkFor(this.allData);
    },
    canViewNotes() {
      return usePrivilegesStore().effectiveGranted(PRIVILEGES.VIEW_NOTES);
    },
    canViewOrders() {
      return usePrivilegesStore().effectiveGranted(PRIVILEGES.ORDER_VIEW);
    },
    canReadDirectives() {
      return usePrivilegesStore().effectiveGranted(PRIVILEGES.DIRECTIVE_READ);
    },
  },
  methods: {
    openNotes() {
      if (!this.canViewNotes) {
        alert("You do not have permission to view notes.");
        return;
      }
      this.$router.push("/notes");
    },
    openOrders() {
      if (!this.canViewOrders) {
        alert("You do not have permission to look at orders.");
        return;
      }
      this.$router.push("/orders");
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../stylesheets/mixins/flex";

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
p {
  margin: 0;
}
.page {
  width: 100%;
  padding-top: 0px;
  padding-bottom: 0px;
}
.record-wrapper {
  max-width: 700px;
  margin: 0 auto;
  padding: 20px 30px 50px 30px;
  border-radius: 5px;
  text-align: center;
}
.header {
  text-align: center;
  .header-icon img {
    width: 60px;
  }
  .header-title {
    font-size: 1.8em;
  }
}
.record {
  @include flex-box();
  @include flex-wrap(wrap);
}
.record-item {
  @include flex(1, 0, 45%);
  margin-top: 10px;
  width: 350px;
}
.record-title {
  @include flex(1, 0, 45%);
  padding: 0 20px;

  .record-subtitle {
    padding: 5px 0;
  }
  .record-explanation {
    font-size: 0.9em;
  }
  .record-link {
    display: block;
    width: 100%;
    font-size: 0.8em;
    border-radius: 3px;
    padding: 5px 0;
    margin-top: 10px;
  }
}
.icon {
  font-size: 2em;
}
@media only screen and (max-width: 768px) {
  .page {
    padding: 0;
  }
  .record-wrapper {
    padding: 30px 10px;
  }
  .record-item {
    @include flex(1, 0, 100%);
    margin-top: 30px;
  }
  .header {
    .header-title {
      font-size: 1.2em;
      font-weight: bold;
    }
    .header-icon img {
      display: none;
    }
  }
}
</style>
